import skiBikeHouseLogo from '../assets/partnerzy/ski-bike-stronie-partner.png'
import { wodospadWilczkiFeaturedPhoto, wodospadWilczkiPhotos } from './wodospadWilczkiPhotos'
import gorskieJezioroImage from '../assets/optimized/gorskie-jezioro-900.webp'
import heroImage from '../assets/optimized/hero-1600.webp'
import journalImage from '../assets/optimized/journal-1200.webp'
import parkBukowiecImage from '../assets/optimized/park-bukowiec-alejka-900.webp'
import section02Image from '../assets/optimized/section02-700.webp'
import { placeStampById } from './placeStamps'
import { newsCoverAbsoluteUrl } from '../lib/seo/newsArticleJsonLd'

export type NewsRichSegment =
  | { type: 'text'; key: string }
  | { type: 'link'; key: string; href: string }

export type NewsBodyBlock =
  | { type: 'paragraph'; key: string; variant?: 'hashtag' }
  | { type: 'richParagraph'; segments: readonly NewsRichSegment[] }
  | { type: 'image'; src: string; altKey: string; captionKey?: string; variant?: 'logo' }

const SKI_BIKE_HOUSE_URL = 'https://skibikehouse.pl/'
const PDS_WEBSITE_URL = 'https://przystanekd.pl'
const PDS_SUBSTACK_URL = 'https://przystanekd.substack.com/'
const PDS_BIBLIOTECZKA_URL = 'https://czytanki.przystanekd.pl'
const PDS_INSTITUTE_URL = 'https://instytutdolnoslaski.org/'
const WODOSPAD_WILCZKI_PLACE_URL = '/miejsca/rezerwat-wodospad-wilczki'
const PALAC_MARIANNY_PLACE_URL = '/miejsca/palac-marianny-oranskiej'

export type NewsPost = {
  id: string
  slug: string
  /** ISO date (YYYY-MM-DD) */
  publishedAt: string
  categoryKey: string
  titleKey: string
  excerptKey: string
  bodyBlocks: readonly NewsBodyBlock[]
  coverImage: string
  /** Okładka z logo: object-contain zamiast przycięcia zdjęcia */
  coverFit?: 'cover' | 'contain'
  /** Blok gwarancji zwrotu pod treścią artykułu */
  showMoneyBackGuarantee?: boolean
}

const pdsPartnerLogo = '/pds-logo-partner.png'

export const newsPosts: readonly NewsPost[] = [
  {
    id: 'wodospad-wilczki-weekend-2026',
    slug: 'wodospad-wilczki-weekend-ciekawostki',
    publishedAt: '2026-06-11',
    categoryKey: 'news.post.wilczkiWeekend.category',
    titleKey: 'news.post.wilczkiWeekend.title',
    excerptKey: 'news.post.wilczkiWeekend.excerpt',
    bodyBlocks: [
      { type: 'paragraph', key: 'news.post.wilczkiWeekend.body1' },
      {
        type: 'image',
        src: wodospadWilczkiFeaturedPhoto?.src ?? wodospadWilczkiPhotos[0]?.src ?? '',
        altKey: 'news.post.wilczkiWeekend.img.waterfall.alt',
        captionKey: 'news.post.wilczkiWeekend.img.waterfall.caption',
      },
      { type: 'paragraph', key: 'news.post.wilczkiWeekend.body2' },
      { type: 'paragraph', key: 'news.post.wilczkiWeekend.body3' },
      { type: 'paragraph', key: 'news.post.wilczkiWeekend.body4' },
      {
        type: 'richParagraph',
        segments: [
          { type: 'text', key: 'news.post.wilczkiWeekend.body5.before' },
          {
            type: 'link',
            key: 'news.post.wilczkiWeekend.link.place',
            href: WODOSPAD_WILCZKI_PLACE_URL,
          },
          { type: 'text', key: 'news.post.wilczkiWeekend.body5.after' },
        ],
      },
      { type: 'paragraph', key: 'news.post.wilczkiWeekend.body6' },
      {
        type: 'richParagraph',
        segments: [
          { type: 'text', key: 'news.post.wilczkiWeekend.body7.before' },
          {
            type: 'link',
            key: 'news.post.wilczkiWeekend.link.palace',
            href: PALAC_MARIANNY_PLACE_URL,
          },
          { type: 'text', key: 'news.post.wilczkiWeekend.body7.after' },
        ],
      },
    ],
    coverImage: wodospadWilczkiFeaturedPhoto?.src ?? wodospadWilczkiPhotos[0]?.src ?? '',
  },
  {
    id: 'partner-sky-bike-house-stronie-2026',
    slug: 'sky-bike-house-stronie-partner-paszportu',
    publishedAt: '2026-06-11',
    categoryKey: 'news.post.skiBikeHouse.category',
    titleKey: 'news.post.skiBikeHouse.title',
    excerptKey: 'news.post.skiBikeHouse.excerpt',
    bodyBlocks: [
      { type: 'paragraph', key: 'news.post.skiBikeHouse.body1' },
      {
        type: 'image',
        src: skiBikeHouseLogo,
        altKey: 'news.post.skiBikeHouse.img.logo.alt',
        captionKey: 'news.post.skiBikeHouse.img.logo.caption',
        variant: 'logo',
      },
      { type: 'paragraph', key: 'news.post.skiBikeHouse.body2' },
      { type: 'paragraph', key: 'news.post.skiBikeHouse.body3' },
      {
        type: 'richParagraph',
        segments: [
          { type: 'text', key: 'news.post.skiBikeHouse.body4.before' },
          { type: 'link', key: 'news.post.skiBikeHouse.link.website', href: SKI_BIKE_HOUSE_URL },
          { type: 'text', key: 'news.post.skiBikeHouse.body4.after' },
        ],
      },
    ],
    coverImage: skiBikeHouseLogo,
    coverFit: 'contain',
  },
  {
    id: 'what-is-paszport-2026',
    slug: 'paszport-dolnego-slaska-2026-co-to-jest-i-jak-dziala',
    publishedAt: '2026-06-09',
    categoryKey: 'news.post.whatIs.category',
    titleKey: 'news.post.whatIs.title',
    excerptKey: 'news.post.whatIs.excerpt',
    bodyBlocks: [
      { type: 'paragraph', key: 'news.post.whatIs.body1' },
      { type: 'paragraph', key: 'news.post.whatIs.body2' },
      {
        type: 'image',
        src: parkBukowiecImage,
        altKey: 'news.post.whatIs.img.places.alt',
        captionKey: 'news.post.whatIs.img.places.caption',
      },
      { type: 'paragraph', key: 'news.post.whatIs.body3' },
      {
        type: 'image',
        src: placeStampById[1]!,
        altKey: 'news.post.whatIs.img.stamp.alt',
        captionKey: 'news.post.whatIs.img.stamp.caption',
      },
      { type: 'paragraph', key: 'news.post.whatIs.body4' },
      { type: 'paragraph', key: 'news.post.whatIs.body5' },
      {
        type: 'image',
        src: journalImage,
        altKey: 'news.post.whatIs.img.journal.alt',
        captionKey: 'news.post.whatIs.img.journal.caption',
      },
      { type: 'paragraph', key: 'news.post.whatIs.body6' },
      {
        type: 'richParagraph',
        segments: [
          { type: 'text', key: 'news.post.whatIs.body7.before' },
          {
            type: 'link',
            key: 'news.post.whatIs.link.places',
            href: 'https://paszportdolnegoslaska.pl/miejsca',
          },
          { type: 'text', key: 'news.post.whatIs.body7.mid' },
          {
            type: 'link',
            key: 'news.post.whatIs.link.pricing',
            href: 'https://paszportdolnegoslaska.pl/formularz',
          },
          { type: 'text', key: 'news.post.whatIs.body7.after' },
        ],
      },
    ],
    coverImage: heroImage,
  },
  {
    id: 'partner-przystanek-dolny-slask-2026',
    slug: 'przystanek-dolny-slask-partner-paszportu',
    publishedAt: '2026-05-28',
    categoryKey: 'news.post.pdsPartner.category',
    titleKey: 'news.post.pdsPartner.title',
    excerptKey: 'news.post.pdsPartner.excerpt',
    bodyBlocks: [
      { type: 'paragraph', key: 'news.post.pdsPartner.body1' },
      {
        type: 'image',
        src: pdsPartnerLogo,
        altKey: 'news.post.pdsPartner.img.logo.alt',
        captionKey: 'news.post.pdsPartner.img.logo.caption',
        variant: 'logo',
      },
      {
        type: 'richParagraph',
        segments: [
          { type: 'text', key: 'news.post.pdsPartner.body2.before' },
          {
            type: 'link',
            key: 'news.post.pdsPartner.link.institute',
            href: PDS_INSTITUTE_URL,
          },
          { type: 'text', key: 'news.post.pdsPartner.body2.after' },
        ],
      },
      { type: 'paragraph', key: 'news.post.pdsPartner.body3' },
      {
        type: 'richParagraph',
        segments: [
          { type: 'text', key: 'news.post.pdsPartner.body4.before' },
          { type: 'link', key: 'news.post.pdsPartner.link.website', href: PDS_WEBSITE_URL },
          { type: 'text', key: 'news.post.pdsPartner.body4.after' },
        ],
      },
      {
        type: 'richParagraph',
        segments: [
          { type: 'text', key: 'news.post.pdsPartner.body5.before' },
          { type: 'link', key: 'news.post.pdsPartner.link.substack', href: PDS_SUBSTACK_URL },
          { type: 'text', key: 'news.post.pdsPartner.body5.mid' },
          {
            type: 'link',
            key: 'news.post.pdsPartner.link.biblioteczka',
            href: PDS_BIBLIOTECZKA_URL,
          },
          { type: 'text', key: 'news.post.pdsPartner.body5.after' },
        ],
      },
    ],
    coverImage: pdsPartnerLogo,
    coverFit: 'contain',
  },
  {
    id: 'launch-paszport-2026',
    slug: 'premiera-paszport-dolnego-slaska',
    publishedAt: '2026-05-17',
    categoryKey: 'news.post.launch.category',
    titleKey: 'news.post.launch.title',
    excerptKey: 'news.post.launch.excerpt',
    bodyBlocks: [
      { type: 'paragraph', key: 'news.post.launch.body1' },
      {
        type: 'image',
        src: journalImage,
        altKey: 'news.post.launch.img.journal.alt',
        captionKey: 'news.post.launch.img.journal.caption',
      },
      { type: 'paragraph', key: 'news.post.launch.body2' },
      {
        type: 'image',
        src: parkBukowiecImage,
        altKey: 'news.post.launch.img.places.alt',
        captionKey: 'news.post.launch.img.places.caption',
      },
      { type: 'paragraph', key: 'news.post.launch.body3' },
      {
        type: 'image',
        src: placeStampById[1]!,
        altKey: 'news.post.launch.img.stamp.alt',
        captionKey: 'news.post.launch.img.stamp.caption',
      },
      { type: 'paragraph', key: 'news.post.launch.body4' },
      {
        type: 'image',
        src: gorskieJezioroImage,
        altKey: 'news.post.launch.img.landscape.alt',
        captionKey: 'news.post.launch.img.landscape.caption',
      },
      { type: 'paragraph', key: 'news.post.launch.hashtag', variant: 'hashtag' },
      { type: 'paragraph', key: 'news.post.launch.body5' },
    ],
    coverImage: heroImage,
  },
  {
    id: 'money-back-guarantee-2026',
    slug: 'gwarancja-ceny-i-zwrot-pieniedzy',
    publishedAt: '2026-05-16',
    categoryKey: 'news.post.guarantee.category',
    titleKey: 'news.post.guarantee.title',
    excerptKey: 'news.post.guarantee.excerpt',
    bodyBlocks: [
      { type: 'paragraph', key: 'news.post.guarantee.body1' },
      { type: 'paragraph', key: 'news.post.guarantee.body2' },
      { type: 'paragraph', key: 'news.post.guarantee.body3' },
    ],
    coverImage: section02Image,
    showMoneyBackGuarantee: true,
  },
] as const

export function getNewsPosts(): NewsPost[] {
  return [...newsPosts].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt))
}

export function getNewsPostBySlug(slug: string): NewsPost | undefined {
  return newsPosts.find((p) => p.slug === slug)
}

export function collectNewsArticleImageUrls(post: NewsPost): string[] {
  const urls = [newsCoverAbsoluteUrl(post.coverImage)]
  for (const block of post.bodyBlocks) {
    if (block.type === 'image') {
      urls.push(newsCoverAbsoluteUrl(block.src))
    }
  }
  return [...new Set(urls)]
}
